var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9241 46.9298C13.0645 46.9298 9.125 43.8887 9.125 39.4297C9.125 34.9707 13.0645 31.356 17.9241 31.356C18.2546 31.356 18.5808 31.3727 18.9018 31.4052V31.356H19.0228C18.9429 30.7682 18.9018 30.1694 18.9018 29.5618C18.9018 21.6347 25.9053 15.2085 34.5446 15.2085C40.3949 15.2085 45.4951 18.1553 48.1784 22.5195C48.8341 22.431 49.505 22.3851 50.1875 22.3851C57.7469 22.3851 63.875 28.0081 63.875 34.9443C63.875 40.6541 59.7224 45.0068 54.0371 46.4415M36.068 57.7918V37.187M36.068 37.187L27.0898 45.6847M36.068 37.187L45.0547 45.6847",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload01);
export default __webpack_public_path__ + "static/media/Upload 01.53bf097e5f69152582a8c7a1bbdfbb77.svg";
export { ForwardRef as ReactComponent };